import React from "react";
import { InputLabel, MenuItem, Select } from "@material-ui/core";

import { useTranslation } from "react-i18next";

export default function PeriodSelector({ label, onChange, value }) {
  const { t } = useTranslation();

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const values = [
    {
      id: "week",
      label: t("period.values.week.label"),
    },
    {
      id: "two-weeks",
      label: t("period.values.twoWeeks.label"),
    },
    {
      id: "month",
      label: t("period.values.month.label"),
    },
    {
      id: "all",
      label: t("period.values.all.label"),
    },
  ];

  return (
    <>
      <InputLabel shrink id="period-select-label">{label}</InputLabel>
      <Select
        labelId="period-select-label"
        id="period-select"
        value={value}
        onChange={handleChange}
        style={{ width: "100%" }}
      >
        {values.map(({ id, label }) => {
          return (
            <MenuItem key={id} value={id}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
}
